import React from 'react';
import { useIsMobile } from '@/lib/utils/useIsMobile';

export function MobileTest() {
  const isMobile = useIsMobile();
  
  return (
    <div style={{ padding: '20px' }}>
      <h1>Mobile Test Page</h1>
      <p>Is Mobile: {isMobile ? 'Yes' : 'No'}</p>
      <p>Window Width: {typeof window !== 'undefined' ? window.innerWidth : 'N/A'}</p>
      <p>User Agent: {typeof navigator !== 'undefined' ? navigator.userAgent : 'N/A'}</p>
      <p>Touch Support: {typeof window !== 'undefined' && 'ontouchstart' in window ? 'Yes' : 'No'}</p>
      <p>Max Touch Points: {typeof navigator !== 'undefined' ? navigator.maxTouchPoints : 'N/A'}</p>
    </div>
  );
}